<h3>{{ 'lang.clientManagement.invitations.incoming' | translate }}</h3>

<div class="tw-min-h-[500px]">
  <sb-table-wrapper-new
    headline="{{'lang.clientManagement.invitations.incoming' | translate}}"
    [isInIntegratedContext]="true"
    [itemsData]="data"
    (paginationChange)="requestDebounced($event)"
    [loading]="loading()"
    [itemName]="'invitations'">

    <!------------------------------

          Filter Panel

    ------------------------------->
    <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
      <sb-filter-panel
        (filterChange)="applyFiltering($event)"
        [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
        [config]="filterConfig"
      >

      </sb-filter-panel>
    </div>

    <!------------------------------

          Table Header

    ------------------------------->
    <ng-template #thead>
      <tr>
        <th>

        </th>
        <th>
          {{ 'lang.globals.id' | translate }}
        </th>
        <th>
          {{ 'lang.globals.name' | translate }}
        </th>
        <th>
          {{ 'lang.globals.createdAt' | translate }}
        </th>
        <th>
          {{ 'lang.address.street' | translate }}
        </th>
        <th>
          {{ 'lang.address.city' | translate }}
        </th>
        <th class="sticky-col last-col">
          {{ 'lang.globals.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <!------------------------------

  Table Body

  ------------------------------->
    <ng-template #tbody let-invitation>
      <tr>
        <td>
          <img *ngIf="invitation?.requesting?.logo"
               style="width: 3rem; height: 3rem;"
               [src]="invitation?.requesting?.logo.url">
        </td>
        <td>
          {{ invitation?.requesting?.id }}
        </td>
        <td>
          {{ invitation?.requesting?.name }}
        </td>
        <td>
          {{ invitation?.createdAt | date: 'dd.MM.yy HH:mm:ss' }}
        </td>
        <td>
          {{ invitation?.requesting?.address?.street }}
        </td>
        <td>
          {{ invitation?.requesting?.address?.city }}
        </td>
        <td class="tr bw sticky-col last-col">
          <sb-split-button
            [splitButtonItems]="invitation.sbButtons ?? []"
            (selectedAction)="resolveSplitButtonAction(invitation, $event)"
          ></sb-split-button>
        </td>
      </tr>
    </ng-template>
    <!------------------------------

      Card Element

  ------------------------------->
    <!-- No card element -->

  </sb-table-wrapper-new>
</div>
